jQuery(document).ready(function($) {

  disease_link = false;

  //Detect change search input
	$('.js-headsearching-search').on('input', function() {
      search = $(this).val();

      //alespoň 2 znaky
      if(search.length < 2) {
        $('.whisper').hide();
        disease_link = false;
        return false;
      }


      params = {};
      params.search = search;
      
      var ajaxUrl =  '/wp-admin/admin-ajax.php';
      $.post(ajaxUrl, {
          action:"whisper_ajax",
          data: params,
          dataType: "json",
      contentType : "application/json;charset=utf-8",
      }).done(function(result_json){
          if(result_json.length) {
            result = jQuery.parseJSON(result_json);
            disease_link = result.disease_link; //need for classic submit form
            $('.whisper').html(result.whisper).show();
          }
      });
  });


  //submit form
  $('.js-headsearching-form').submit(function (e) { 
    e.preventDefault();
    //classic submit to classic fulltext search
    if(disease_link == false) {
      $(this).off('submit').submit();
    } else {
      //redirect to disease
      window.location.href = disease_link;
    }
    
  });

  //Close whisper on click outside
  $(document).mouseup(function(e){
      var container = $('.whisper,.js-headsearching-search');
      // If the target of the click isn't the container
      if(!container.is(e.target) && container.has(e.target).length === 0){
          $('.whisper').hide();
      }
  });

});